import { render, staticRenderFns } from "./CashiersLimits.vue?vue&type=template&id=a0e5ec94"
import script from "./CashiersLimits.vue?vue&type=script&lang=js"
export * from "./CashiersLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports